<template>
	<div>
		<div class="set_indexBox" >
			<div class="set_tit">Setting</div>
			<div class="setting_optionsBox">
				<span class="options_msg">Ask Questions</span>
			</div>
			<div class="setting_optionsBox">
				<span class="options_msg">Feature Ideas</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
        return {}
	},
}
</script>

<style lang="scss">

	.set_indexBox{
		width: 100%;
		.set_tit{
			height:33px;
			font-size:24px;
			font-weight:600;
			color:var(--text-color);
			line-height:33px;
			margin-bottom: 39px;
		}
		.setting_optionsBox{
			display: flex;
			align-items: center;
			padding: 20px 30px;
			background:var(--background-color-3);
			//height: 70px;
			margin-bottom: 30px ;
			cursor: pointer;
			.options_msg{
				//height:28px;
				font-size:20px;
				font-family:PingFang SC;
				font-weight:600;
				color:var(--text-color);
				line-height:28px;
			}
			.optionsItem_msg{
				margin-left: auto;
				margin-right: 15px;
				font-size: 16px;
				font-weight: 400;
				color: var(--text-color);
			}
			.option_unlink{
				margin-left: auto;
				height:28px;
				font-size:20px;
				font-family:PingFangSC-Regular,PingFang SC;
				font-weight:400;
				color:var(--text-color);
				line-height:28px;
				text-decoration: underline;
				cursor: pointer;
				&::before{
					content: '';
					display: inline-block;
					width:12px;
					height:12px;
					background:rgba(234,55,150,1);
					border-radius:6px;
					margin-right: 10px;
				}
			}
			.option_unlink1{
				margin-left: auto;
				width: 222px;
				height: 43px;
				background: url('../../../static/img/xeo1.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: right;
			}
			.option_link1{
				min-width: 222px;
				margin-left: auto;
				height: 43px;
				background-image: url('../../../static/img/p.png');
				background-repeat: no-repeat;
				background-size: 33px auto;
				background-position: 9px center;
				background-color: #0D83A9;
				border-radius: 3px;
				box-sizing: border-box;
				padding: 0 10px 0 60px;
				font-size: 14px;
				line-height: 43px;
				color: var(--text-color);
			}
			.option_unlink3{
				margin-left: auto;
				width: 222px;
				height: 43px;
				background: url('../../../static/img/bb.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: right;
			}
			.option_link3{
				margin-left: auto;
				width: 222px;
				height: 43px;
				background: url('../../../static/img/dd2.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: right;
			}
			.option_unlink2{
				margin-left: auto;
				width: 222px;
				height: 43px;
				background: url('../../../static/img/ctx2.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: right;
			}
			.option_link2{
				margin-left: auto;
				width: 222px;
				height: 43px;
				background: url('../../../static/img/cxt2.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: right;
			}
			.option_link{
				margin-left: auto;
				height:28px;
				font-size:20px;
				font-family:PingFangSC-Regular,PingFang SC;
				font-weight:400;
				color:var(--text-color);
				line-height:28px;
				text-decoration: underline;
				cursor: pointer;
				&::before{
					content: '';
					display: inline-block;
					width:12px;
					height:12px;
					background:#3BD578;
					border-radius:6px;
					margin-right: 10px;
				}
			}
			.myset_icon{
				margin-left: auto;
				font-size: 22px;
				color: var(--text-color);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/help/index.vue